import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import KEYS from '../../common/keyCodes';
import Portal from '../../util/portal';
import DropDownBaseOptions from '../dropDownBaseOptions/dropDownBaseOptions';
import { WixBaseUiEnvironmentContext, WixBaseUiEnvironmentProvider } from '../../util/WixBaseUiEnvironment/WixBaseUiEnvironment';
var PREVENT_DEFAULT_KEYS = _.pick(KEYS, ['LEFT', 'UP', 'RIGHT', 'DOWN', 'ENTER', 'SPACE', 'ESC']);
var doneScrolling = function doneScrolling(node, deltaY) {
  return node.scrollTop === 0 && deltaY < 0 || node.scrollTop + node.offsetHeight === node.scrollHeight && deltaY > 0;
};
var getChildrenHeight = function getChildrenHeight(node) {
  return _(node.children).reject(function (child) {
    return _.includes(['fixed', 'absolute'], window.getComputedStyle(child).position);
  }).map('offsetHeight').sum();
};
var DropDownBase = /*#__PURE__*/function (_React$Component) {
  function DropDownBase(props) {
    var _this;
    _classCallCheck(this, DropDownBase);
    _this = _callSuper(this, DropDownBase, [props]);
    _this.state = {
      isOpen: false,
      arrows: {
        up: false,
        down: false
      }
    };
    _this.isOpen = function () {
      return _this.props.customToggle ? _this.props.isOpen : _this.state.isOpen;
    };
    _this.toggleFunc = _this.props.customToggle ? _this.props.customToggle : function (isOpen) {
      return _this.setState({
        isOpen: _.isUndefined(isOpen) ? !_this.state.isOpen : isOpen
      }, _this.onToggle);
    };
    _this.toggleOptions = function (isOpen, origin, event) {
      if (_this.props.stopPropagationOnToggle && event !== null && event !== void 0 && event.stopPropagation) {
        event.stopPropagation();
      }
      return _this.props.disabled || origin === 'click' && _this.props.openOnHover ? _.noop() : _this.toggleFunc(isOpen);
    };
    _this.onToggle = function () {
      var isOpen = _this.isOpen();
      _this.optionsNode = isOpen && _this.optionsPortal ? ReactDOM.findDOMNode(_this.props.showCustomScroll ? _this.optionsPortal.refs.optionsInner.innerContainer : _this.optionsPortal.refs.optionsInner) : null;
      _this.onLayoutChange();
      _this.registerLastWindowScrollPosition();
      _this.cancelOptionsScroll();
      if (_.isFunction(_this.props.onToggle)) {
        _this.props.onToggle(isOpen);
      }
    };
    _this.updateArrow = function () {
      return _this.isOpen() && _this.optionsNode ? _this.setState({
        arrows: _this.getArrows()
      }) : _.noop();
    };
    _this.onLayoutChange = function () {
      if (_this.props.onLayoutChange) {
        _this.props.onLayoutChange(_this.getOptionsRect(), _this.optionsNode);
      }
      _this.arrowsTimer = window.setTimeout(function () {
        return _this.updateArrow();
      }, 0);
    };
    _this.createLayoutTimer = function () {
      window.clearTimeout(_this.layoutTimer);
      _this.layoutTimer = window.setTimeout(function () {
        return _this.onLayoutChange();
      }, 0);
    };
    _this.getOptionsRect = function () {
      if (_this.optionsNode) {
        var selectedRect = ReactDOM.findDOMNode(_this.refs.selected).getBoundingClientRect();
        var optionsStyle = window.getComputedStyle(_this.optionsNode);
        var height = _this.optionsNode.scrollHeight;
        var width = selectedRect.width;
        if (_this.pendingHeightChange) {
          _this.pendingHeightChange = false;
          var padding = parseInt(optionsStyle.paddingTop, 10) + parseInt(optionsStyle.paddingBottom, 10);
          height = getChildrenHeight(_this.optionsNode) + padding;
        }
        if (_this.props.keepOptionsWidth && !_this.props.showCustomScroll) {
          var isScrollHidden = _.get(_this, 'props.optionsInnerStyle.width');
          var widthWithoutScrollBar = isScrollHidden ? _this.optionsNode.clientWidth : _this.optionsNode.offsetWidth;
          var horizontalPadding = parseInt(optionsStyle.paddingLeft, 10) + parseInt(optionsStyle.paddingRight, 10);
          width = Math.max(widthWithoutScrollBar - horizontalPadding, selectedRect.width);
        }
        return {
          top: selectedRect.top + selectedRect.height,
          left: selectedRect.left,
          width: width,
          height: height
        };
      }
    };
    _this.onWindowResize = function () {
      _this.createLayoutTimer();
    };
    _this.shouldBlockScroll = function (node, deltaY) {
      return doneScrolling(node, deltaY) || _this.props.customBlockScroll && _this.props.customBlockScroll(node, deltaY);
    };
    _this.handleArrowsScroll = function (deltaY) {
      var node = _this.optionsNode;
      var shouldScroll = _this.isOpen() && !_this.shouldBlockScroll(node, deltaY);
      if (shouldScroll) {
        node.scrollTop += deltaY;
      }
      _this.updateArrow();
    };
    _this.handleScroll = function (e) {
      if (_this.isOpen()) {
        if (_this.props.blockScroll && !_this.props.allowInnerScroll) {
          var node = _this.optionsNode;
          var shouldBlockScroll = _this.shouldBlockScroll(node, e.deltaY) || !node.contains(e.target);
          if (shouldBlockScroll) {
            e.preventDefault();
            e.stopPropagation();
          }
          _this.updateArrow();
        } else if (_this.props.allowInnerScroll) {
          _this.onLayoutChange();
        }
      }
    };
    _this.registerLastWindowScrollPosition = function () {
      _this.lastWindowScrollPosition = {
        x: window.scrollX,
        y: window.scrollY
      };
    };
    _this.blockScrollOutOfWindow = function () {
      if (_this.isOpen()) {
        if (_this.props.blockScroll) {
          var _this$lastWindowScrol = _this.lastWindowScrollPosition,
            x = _this$lastWindowScrol.x,
            y = _this$lastWindowScrol.y;
          window.scrollTo(x, y);
        } else {
          _this.onLayoutChange();
        }
      }
    };
    _this.getArrows = function () {
      var inner = _this.optionsNode;
      var up = inner && inner.scrollTop > 0;
      var down = inner && inner.scrollTop + inner.offsetHeight < inner.scrollHeight;
      return {
        up: up,
        down: down
      };
    };
    _this.handleKeyDown = function (e) {
      var isOpen = _this.isOpen();
      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e, isOpen);
      }
      if (isOpen) {
        var inputElementToAllowEvents = ReactDOM.findDOMNode(_this.props.inputToAllowEvents);
        var shouldAllowKeyDown = inputElementToAllowEvents === e.target;
        var isTargetContainedInOptions = _.isElement(_this.optionsNode) && _.isElement(e.target) && _this.optionsNode.contains(e.target);
        if (_(PREVENT_DEFAULT_KEYS).values().includes(e.keyCode) && !shouldAllowKeyDown && !isTargetContainedInOptions) {
          e.stopPropagation();
          e.preventDefault();
        }
        if (_.includes(_this.props.customCloseKeys || [KEYS.ENTER, KEYS.ESC, KEYS.SPACE], e.keyCode)) {
          _this.toggleOptions(false);
        }
        _this.updateArrow();
      }
    };
    _this.onScroll = function (e) {
      if (_this.props.onOptionsScroll) {
        _this.props.onOptionsScroll(e);
      }
      _this.updateArrow();
    };
    _this.scrollOptions = function (dir) {
      var _this$state$arrows = _this.state.arrows,
        up = _this$state$arrows.up,
        down = _this$state$arrows.down;
      var SPEED = 5;
      _this.handleArrowsScroll(dir * SPEED);
      if (up && dir === -1 || down && dir === 1) {
        _this.scrollAnimationFrame = window.requestAnimationFrame(function () {
          return _this.scrollOptions(dir);
        });
      }
    };
    _this.cancelOptionsScroll = function () {
      return window.cancelAnimationFrame(_this.scrollAnimationFrame);
    };
    _this.closeIfOpen = function () {
      return _this.isOpen() ? _this.toggleOptions(false) : _.noop();
    };
    _this.onClickOutside = function () {
      if (_this.props.closeOnClickOutside) {
        _this.closeIfOpen();
      }
    };
    _this.registerOptions = function (options) {
      if (_this.optionsPortal !== options) {
        _this.optionsPortal = options;
        _this.onToggle();
      }
    };
    _this.getOptionsProps = function () {
      return _.assign({}, _this.state, _this.props, {
        optionsStyle: _.omitBy(_this.props.optionsStyle, function (value, key) {
          return window.isNaN(value) && !key.startsWith('--');
        }),
        onMouseEnter: _this.handleMouseEnter,
        onMouseLeave: _this.handleOptionsMouseLeave
      }, _.pick(_this, ['scrollOptions', 'onScroll', 'cancelOptionsScroll', 'onClickOutside', 'registerLastWindowScrollPosition', 'registerOptions']));
    };
    _this.optionsMountPoint = null;
    _this.addOptionsMountPoint = function () {
      if (!_this.optionsMountPoint) {
        _this.optionsMountPoint = window.document.createElement('div');
        window.document.body.appendChild(_this.optionsMountPoint);
      }
      return _this.optionsMountPoint;
    };
    _this.removeOptionsMountPoint = function () {
      if (_this.optionsMountPoint) {
        window.document.body.removeChild(_this.optionsMountPoint);
        _this.optionsMountPoint = null;
      }
    };
    _this.handleMouseEnter = function () {
      if (!props.openOnHover) {
        return;
      }
      _this.toggleOptions(true);
    };
    _this.handleOptionsMouseLeave = function () {
      if (props.onOptionsMouseLeave) {
        props.onOptionsMouseLeave();
      }
    };
    return _this;
  }
  _inherits(DropDownBase, _React$Component);
  return _createClass(DropDownBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.node = ReactDOM.findDOMNode(this);
      if (this.props.onLayoutChange) {
        window.addEventListener('resize', this.onWindowResize);
      }
      if (this.props.closeOnWindowBlur) {
        window.addEventListener('blur', this.closeIfOpen);
      }
      window.addEventListener('scroll', this.blockScrollOutOfWindow);
      window.addEventListener('wheel', this.handleScroll);
      window.addEventListener('keydown', this.handleKeyDown, this.props.captureKeyboardEvents);
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      if (this.props.isOpen) {
        this.addOptionsMountPoint();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.onLayoutChange) {
        window.removeEventListener('resize', this.onWindowResize);
      }
      if (this.props.closeOnWindowBlur) {
        window.removeEventListener('blur', this.closeIfOpen);
      }
      window.removeEventListener('scroll', this.blockScrollOutOfWindow);
      window.removeEventListener('wheel', this.handleScroll);
      window.removeEventListener('keydown', this.handleKeyDown, this.props.captureKeyboardEvents);
      window.clearTimeout(this.arrowsTimer);
      window.clearTimeout(this.layoutTimer);
      this.cancelOptionsScroll();
      this.removeOptionsMountPoint();
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps, nextState) {
      var shouldCloseOptions = this.props.customToggle ? !nextProps.isOpen : !nextState.isOpen;
      if (shouldCloseOptions) {
        this.removeOptionsMountPoint();
      } else {
        this.addOptionsMountPoint();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var selectedChanged = prevProps.selected.key ? prevProps.selected.key !== this.props.selected.key : prevProps.selected !== this.props.selected;
      if (selectedChanged) {
        this.toggleOptions(false);
      }
      if (this.props.forceOpen && !prevProps.forceOpen) {
        this.toggleOptions(true);
      }
      var contentKeyChanged = _.get(this, 'props.options.key') !== _.get(prevProps, 'options.key');
      var optionsLengthChanged = this.props.options.length !== prevProps.options.length;
      var optionsArr = _.castArray(this.props.options);
      var prevOptionsArr = _.castArray(prevProps.options);
      var optionsChanged = _.differenceBy(optionsArr, prevOptionsArr, 'props.label').length;
      var contentChanged = contentKeyChanged || optionsChanged;
      if (optionsLengthChanged || contentKeyChanged) {
        this.pendingHeightChange = true;
      }
      if (contentChanged) {
        this.createLayoutTimer();
      }
    }
  }, {
    key: "handleDropdownBaseOptionsClick",
    value: function handleDropdownBaseOptionsClick(event) {
      event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        className: this.props.getClassName('control-dropdown-base') + (this.props.disabled ? ' disabled' : ''),
        disabled: this.props.disabled,
        "data-label": this.props.dataLabel,
        onMouseEnter: this.handleMouseEnter
      }, /*#__PURE__*/React.createElement("div", {
        "data-hook": "drop-down-input",
        className: ['dropdown-selected', this.isOpen() ? 'is-open' : ''].join(' '),
        style: this.props.inputStyle ? this.props.inputStyle : null,
        ref: "selected",
        onClick: this.toggleOptions.bind(this, undefined, 'click')
      }, this.props.selected), this.isOpen() && this.optionsMountPoint ? /*#__PURE__*/React.createElement(Portal, {
        container: this.optionsMountPoint,
        key: "with-portal"
      }, /*#__PURE__*/React.createElement(WixBaseUiEnvironmentProvider, this.context, /*#__PURE__*/React.createElement(DropDownBaseOptions, _.assign({}, {
        onClick: this.handleDropdownBaseOptionsClick
      }, this.getOptionsProps())))) : null);
    }
  }]);
}(React.Component);
DropDownBase.displayName = displayNames.DROP_DOWN_BASE;
var nodeType = PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.node.isRequired, PropTypes.element.isRequired]);
DropDownBase.propTypes = {
  disabled: PropTypes.bool,
  inputStyle: PropTypes.object,
  optionsStyle: PropTypes.object,
  optionsInnerStyle: PropTypes.object,
  onLayoutChange: PropTypes.func,
  onOptionsScroll: PropTypes.func,
  onKeyDown: PropTypes.func,
  onToggle: PropTypes.func,
  customBlockScroll: PropTypes.func,
  blockScroll: PropTypes.bool,
  blockClickOutside: PropTypes.bool,
  closeOnClickOutside: PropTypes.bool,
  displayArrow: PropTypes.bool,
  captureKeyboardEvents: PropTypes.bool,
  closeOnWindowBlur: PropTypes.bool,
  customToggle: PropTypes.func,
  isOpen: PropTypes.bool,
  keepOptionsWidth: PropTypes.bool,
  inputToAllowEvents: PropTypes.object,
  // React Ref
  customCloseKeys: PropTypes.arrayOf(PropTypes.number),
  selected: nodeType,
  options: nodeType,
  dataLabel: PropTypes.string,
  forceOpen: PropTypes.bool,
  allowInnerScroll: PropTypes.bool,
  openOnHover: PropTypes.bool,
  hoverCloseTimeout: PropTypes.number,
  onOptionsMouseLeave: PropTypes.func,
  stopPropagationOnToggle: PropTypes.bool,
  showCustomScroll: PropTypes.bool
};
DropDownBase.defaultProps = {
  disabled: false,
  closeOnClickOutside: true,
  displayArrow: true,
  captureKeyboardEvents: true,
  blockClickOutside: true,
  closeOnWindowBlur: true,
  keepOptionsWidth: false,
  allowInnerScroll: false,
  openOnHover: false,
  stopPropagationOnToggle: false,
  hoverCloseTimeout: 200,
  showCustomScroll: false
};
DropDownBase.contextType = WixBaseUiEnvironmentContext;
export default compose(DropDownBase);